import FormBase from "../FormBase";
import Professional from '../../models/Professional'
import FormFieldBase from "../../forms/FormFieldBase";
import ValidationBase, { ValidationType } from "../../forms/ValidationBase";
import RequestService from "../../services/RequestService";
import { SolicitacaoAcompanhamentoClinicoOptions } from "../../data/SolicitacaoAcompanhamentoClinico";
import { SolicitacaoParticipacaoCirurgiaOptions } from "../../data/SolicitacaoParticipacaoCirurgia";


export default class ParticipationRequestForm implements FormBase {

    RequestParticipate: FormFieldBase;
    NameResponsible: FormFieldBase;
    RequestFollow: FormFieldBase;

    constructor(RequestParticipate: string, NameResponsible: string, RequestFollow: string) {

        this.RequestParticipate = new FormFieldBase(RequestParticipate, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
        this.NameResponsible = new FormFieldBase(NameResponsible, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
        this.RequestFollow = new FormFieldBase(RequestFollow, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
    }

    static NewInstance(): ParticipationRequestForm {
        return new ParticipationRequestForm("", "", "");
    }

    ValidateToGoNextStep(): string {

        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }
        }

        if (!formIsValid) {
            return "Por favor, preencha os dados obrigatórios."
        } else {
            return "";
        }
    }

    async CallInsertOrUpdateApi(Professional: Professional): Promise<any> {
        const dataJson = this.getJsonObjet();
        return RequestService.postSpecialauthorization(dataJson, Professional.Id);
    }

    GetFieldByName(name: string): FormFieldBase {
        switch (name) {
            case "RequestParticipate":
                return this.RequestParticipate
            case "NameResponsible":
                return this.NameResponsible
            case "RequestFollow":
                return this.RequestFollow

            default:
                return new FormFieldBase("", []);
        }
    }

    getJsonObjet() {

        return {
            "ProfessionalId": 0,
            "RequestParticipateId": SolicitacaoParticipacaoCirurgiaOptions.find(r => r.value === this.RequestParticipate.Value)?.id, 
            "NameResponsible": this.NameResponsible.Value,
            "RequestFollowId": SolicitacaoAcompanhamentoClinicoOptions.find(r => r.value === this.RequestFollow.Value)?.id
        }
    }
}